module.exports = __webpack_public_path__ + "static/media/api-article.0cbfde3f.jpeg";